import { render, staticRenderFns } from "./CourseInfoCard.vue?vue&type=template&id=024f1269&scoped=true&"
import script from "./CourseInfoCard.vue?vue&type=script&lang=js&"
export * from "./CourseInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseInfoCard.vue?vue&type=style&index=0&id=024f1269&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f1269",
  null
  
)

export default component.exports